import { FC, useState } from "react";
import { DialogData, DialogHandle } from "../../types";
import { useApp } from "../../context/useApp";
import { Icon } from "../../parts/Icon";
import { _, calcMaxChildren, parseNum } from "../../utils/helpers";
import { DEFAULT_DIALOG_HANDLE, SCREEN_BREAKPOINT_3, UNASIGNED_ZONES } from "../../utils/symbols";
import { AddButton } from "../../parts/inputs/AddButton";

interface UnassignedSeatsDialogProps {
    dialogData: DialogData
}

export const UnassignedSeatsDialog: FC<UnassignedSeatsDialogProps> = ({dialogData}) => {

    const {
        state: { dialogHandles, booking, tableMapHandle, products, screen },
        actions: { genericError }
    } = useApp()

    const [ticketsQty, setTicketsQty] = useState(Math.max(1, booking.getTicketQty({
        zone: dialogData.dialog === 'unassigned-seats' ? dialogData.zone : 'za2',
        category: dialogData.dialog === 'unassigned-seats' ? dialogData.category : 'adult',
    })))

    if (dialogData.dialog !== 'unassigned-seats') return null

    const dialogHandle:DialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE
    const zoneOccupation = tableMapHandle.getEventOccupation(dialogData.zone)
    const maxToAdd = (() => {

        if (dialogData.category === 'children') return Math.min(calcMaxChildren(booking.getAdults()), zoneOccupation.available)
        return zoneOccupation.available
    })()

    const handleTicketsQtyChange = (newQty: number) => setTicketsQty(newQty)

    const handleAddEntries = () => {

        const ticketToAdd = products.find(product => product.type === 'ticket' && product.category === dialogData.category && dialogData.zone === product.zone)
        if (!ticketToAdd) {
            genericError(handleAddEntries)
            return
        }

        const ticketQtyInBooking = booking.getProductQty(ticketToAdd.id)
        const toModify = ticketsQty - ticketQtyInBooking

        for (let i = 0; i < Math.abs(toModify); i++) {
            booking.handleProduct(toModify < 0 ? 'remove' : 'add', ticketToAdd)
        }
        
        booking.render()
        dialogHandle.closeDialog()
    }

    return (
        <section
            className="df fd-c jcfs aic r3 section p-r py-10 px-10"
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
            role="region"
        >
            <button 
                className="button b-0 p-2 mt-0 p-a zi-6 close df aic jcc outline-shadow"
                onClick={() => dialogHandle.closeDialog()}
                aria-label={_('0ar_close__')}
                role="button"
            >
                <Icon icon="close" aria-hidden/>
            </button>
            <h2 id="dialog-title" className="text s20-600 center mt-9 mb-6" aria-hidden>{_('3di_unass__')}</h2>
            <p id="dialog-description" className="text s20-400 center" aria-hidden dangerouslySetInnerHTML={{__html: _('3di_thisp__')}}></p>
            <AddButton 
                alwaysDisplayCounter
                qty={ticketsQty}
                min={0}
                max={maxToAdd}
                onAddButtonClick={handleTicketsQtyChange}
                className="mt-9 mb-10"
            />
            <button 
                className="button b-0 px-10 py-7 df aic jcc black text s20-500 r3"
                onClick={handleAddEntries}
            >
                <span className="mr-5">{`${booking.getTicketQty({zone: dialogData.zone, category: dialogData.category}) === 0 ? _('0ge_add____') : _('0ge_updat__')}  ${_('3di_unass__').toLocaleLowerCase()}`}</span>
                {screen.width > SCREEN_BREAKPOINT_3 && (<Icon icon={'arrow'} className="rt-180"/>)}
            </button>
            
        </section>
    )
}